import { Injectable, inject } from "@angular/core";
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  readonly #gtmService = inject(GoogleTagManagerService);

  pushTag(tag: { [key: string]: string|number }) {
    if (!environment.production) {
      return;
    }

    this.#gtmService.pushTag(tag);
  }
}